import Gumshoe from "gumshoejs";


// Get ToC nav by id
const toc = document.getElementById('toc');


// If the toc exists
if (toc) {
    // Enable scrollspy
    const spy = new Gumshoe('#toc a', {
        offset: 350
    });

    // Add eventlisteners to document after DOM is loaded and on scroll to check for active table-of-contents items
    document.addEventListener('DOMContentLoaded', activeTocItemFallback);
    document.addEventListener('scroll', activeTocItemFallback);
}


/**
 * Helper function to check for active items in the table-of-contents list.
 * If there is no active item, the first item of the list will be set as 'active'.
 */
function activeTocItemFallback() {
    const activeElements = toc.querySelectorAll('.active');
    if (activeElements.length === 0) {
        const firstItem = toc.querySelector('li:first-child');
        firstItem.classList.add('active');
    }
}